import { render } from "./BookingConfirmed.vue?vue&type=template&id=489e50ed&scoped=true"
import script from "./BookingConfirmed.vue?vue&type=script&lang=js"
export * from "./BookingConfirmed.vue?vue&type=script&lang=js"

import "./BookingConfirmed.vue?vue&type=style&index=0&id=489e50ed&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489e50ed"]])

export default __exports__